import axios from 'axios';
const publicUrl = process.env.PUBLIC_URL;

let isLoggingOut = false;

const api = axios.create({
    baseURL: process.env.REACT_APP_URL,
    withCredentials: true,

    //withXSRFToken: true
    // set headers here with token from local storage
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
});

// interceptors from axios handle 401 errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            // 401
            if (error.response.status === 401) {
                //console.log('401 error');
                if (!isLoggingOut) {
                    isLoggingOut = true;
                    handleLogout();
                }
            }
            // 422
            if (error.response.status === 422) {
                return Promise.reject(error.response.data);
            }
            // 500
            if (error.response.status === 500) {
                // convert error to message
                const errorData = error.response.data;
                if (errorData.message) {
                    return Promise.reject({ errors: [errorData.message] }); // convert to server error message
                } else {
                    return Promise.reject(errorData);
                }
            }
            // 404 redirect to notfound page
            if (error.response.status === 404) {
                window.location.href = publicUrl + '/#/notfound';
            }

            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);

function handleLogout() {
    // Preusmeravanje na logout stranicu
    localStorage.removeItem('is-user-loged-id');
    window.location.href = publicUrl + '/#/login';
    // Funkcija za zaustavljanje svih budućih poziva
    // api.interceptors.request.use((config) => {
    //     return Promise.reject('Zaustavljeni su svi zahtevi zbog 401 greške');
    // });
}

export default api;
